import React, { useState } from 'react';
import { Account } from '../../types/api';
import { AccountList } from './AccountList';
import { AccountModal } from './AccountModal';

export const AccountManagement: React.FC = () => {
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [editingAccount, setEditingAccount] = useState<Account | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleCreateAccount = () => {
    setEditingAccount(null);
    setShowAccountModal(true);
  };

  const handleEditAccount = (account: Account) => {
    setEditingAccount(account);
    setShowAccountModal(true);
  };

  const handleCloseModal = () => {
    setShowAccountModal(false);
    setEditingAccount(null);
  };

  const handleSaveAccount = (savedAccount: Account) => {
    setShowAccountModal(false);
    setEditingAccount(null);
    // Trigger refresh of account list
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <>
      <AccountList
        refreshTrigger={refreshTrigger}
        onCreateAccount={handleCreateAccount}
        onEditAccount={handleEditAccount}
      />

      <AccountModal
        account={editingAccount}
        isOpen={showAccountModal}
        onClose={handleCloseModal}
        onSave={handleSaveAccount}
      />
    </>
  );
};